import { useEffect, useState } from "react";
import "./styles.css";
import Header from "./header.js";
import Display from "./display.js";

export default function App() {
  let [darkMode, setDarkMode] = useState(false);
  let [data, setData] = useState();
  let [isFetched, setIsFetched] = useState(false);

  const trending = async () => {
    await fetch(
      "https://api.giphy.com/v1/gifs/trending?api_key=D6TZBIoCG1TNnpy8EAt5q7hvovUd1NHF"
    )
      .then((response) => response.json())
      .then((data) => {
        setData(data);
        setIsFetched(true);
      })
      .catch((error) => console.log(error));
  };

  useEffect(() => {
    trending();
  }, []);

  return (
    <div className={darkMode ? "App-dark" : "App"}>
      <div className="search-bar">
        <Header
          darkMode={darkMode}
          setDarkMode={setDarkMode}
          setData={setData}
        />
        <Display darkMode={darkMode} data={data} isFetched={isFetched} />
      </div>
    </div>
  );
}
